import styled from "styled-components";
// import logo from "../../../assets/img/illustrations/home-jadwal.svg"

export const CardContainer = styled.div`
  background-image: ${(props) => `url('${props.img}')`};
  background-size: cover;
  background-repeat: no-repeat;
  max-width: ${(props) => props?.width};
  min-width: ${(props) => props?.width};
  height: ${(props) => props?.height};
  display: flex;
  align-items: center;
  border: 1px solid #f0f2f9;
  border-radius: 16px;
  background-color: ${(props) => props?.backgroundColor || "inherit"};
`;

export const InnerCardContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => props?.flexDirection || "column"};
  align-items: ${(props) => props?.alignItems || "start"};
  padding: 12px 12px;
  gap: 8px;
  align-self: ${(props) => props?.alignSelf || "center"};
`;

export const TypographyBold = styled.p`
  margin: 0;
  font-family: "Gilroy";
  font-weight: bold;
  font-size: 11px;
  line-height: 13px;

  @media only screen and (min-width: 769px) {
    font-size: 14px;
    line-height: 14px;
  }
`;

export const ImageBadge = styled.img`
  width: 24px;
  height: 24px;

  @media only screen and (min-width: 769px) {
    width: 40px;
    height: 40px;
  }
`;
